<template>
  <div class="gnb-slider gnb-scroll">
    <Swiper
      v-scroll-spy-active="{ selector: '.gnb-slider__item', class: 'active' }"
      class="gnb-slider__swiper"
      :modules="modules"
      :direction="'vertical'"
      :slides-per-view="2"
      :grid="{
        fill: 'row',
        rows: configStore.config.MenuGroupCountPerLine || 4,
      }"
      :free-mode="true"
      :space-between="0"
      @swiper="onSwiper"
    >
      <SwiperSlide
        v-for="(menuGroup, index) in props.menuGroups"
        :key="index"
        :class="`col-${configStore.config.MenuGroupCountPerLine || 4}`"
      >
        <a :href="`#menu${index}`" class="gnb-slider__item">
          {{ getNameByLocale(menuGroup) }}
        </a>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
  import MenuGroup from '@/interfaces/MenuGroup';
  import { useConfigStore } from '@/stores/config';
  import { useSwiperStore } from '@/stores/swiper';
  import { getNameByLocale } from '@/utils';
  import SwiperClass from 'swiper';
  import { FreeMode, Grid } from 'swiper/modules';
  import 'swiper/swiper-bundle.css';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { ref } from 'vue';

  interface Props {
    menuGroups: MenuGroup[];
  }

  const configStore = useConfigStore();
  const props = defineProps<Props>();

  // swiper 에 사용 될 모듈
  const modules = ref([FreeMode, Grid]);
  // swiper 지정
  //const gnbSwiper = ref();
  // 현재 활성화 된 메뉴
  //const currentActive = ref(0);

  /**
   * swiper 실행 시 해당 swiper option 할당
   * @param swiper
   */
  const onSwiper = (swiper: SwiperClass) => {
    //gnbSwiper.value = swiper;
    useSwiperStore().setMenuGroupScroll(swiper);
  };
</script>
